import { useRef } from "react";

// Enter sends the form the text box is in; Shift+Enter is a new line, and
// Enter that confirms an IME composition (Japanese, Chinese) does not send.
// `formRef` is only needed to submit from elsewhere (a suggested prompt).
export function useSubmit() {
  const formRef = useRef(null);

  const handleKeyDown = (event) => {
    if (
      !event.shiftKey &&
      !event.nativeEvent.isComposing &&
      event.nativeEvent.keyCode !== 229 &&
      event.key === "Enter"
    ) {
      (event.currentTarget.form ?? formRef.current)?.requestSubmit();
      event.preventDefault();
    }
  };

  return { formRef, onKeyDown: handleKeyDown };
}
